import { CoreDataSecurityApplicationsAllName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityApplicationsAll } from '@api/data-security';
import { updateApplicationReferences } from '../_idMap/actions';

export const getCoreDataSecurityApplicationsAllSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successDataActionCreators: [ (response) => updateApplicationReferences(response.results) ]
	},
	name: CoreDataSecurityApplicationsAllName,
	receive: true,
	request: true,
	requestHandler: getDataSecurityApplicationsAll,
	retainDataOnRequest: true
});
